<script setup lang="ts">
import UIKit from '@pocketprep/ui-kit'

const {
    Button: PocketButton,
    Icon,
} = UIKit

const props = defineProps<{
    isLoading: boolean
    error?: string | null
}>()

const emit = defineEmits<{
    'close': []
    'addStudents': []
    'contactSupport': []
}>()

</script>

<template>
    <div class="purchase-success">
        <Icon
            class="purchase-success__close-icon"
            type="close"
            @click="emit('close')"
        />
        <div class="purchase-success__title">
            <slot name="successTitle">
                <div>Seats Purchased</div>
            </slot>
        </div>
        <div class="purchase-success__message">
            <slot name="successMessage">
                <div class="purchase-success__message-paragraph">
                    Thanks for your purchase! <br>
                    Your students are in good company, joining 91,695<br>
                    people also using Pocket Prep to help them pass.
                </div>
                <div
                    v-if="props.isLoading"
                    class="purchase-success__seats-loading">
                    Creating seat licenses...
                </div>
                <div
                    v-else-if="props.error"
                    class="purchase-success__seats-error"
                >
                    {{ props.error }}
                </div>
                <div v-else>
                    Next up, add students to start using these seats.
                </div>
            </slot>
        </div>
        <PocketButton
            v-if="props.error"
            class="purchase-success__contact-support-btn"
            :isLoading="props.isLoading"
            @click="emit('contactSupport')"
        >
            Contact Support
        </PocketButton>
        <PocketButton
            v-else
            class="purchase-success__add-students-btn"
            :isLoading="props.isLoading"
            @click="emit('addStudents')"
        >
            Add Students
        </PocketButton>
        <img
            class="purchase-success__image"
            src="@/assets/upgradeModal/purchase-success.png"
        >
    </div>
</template>

<style lang="scss" scoped>
.purchase-success {
    background-color: $floral-white;
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;

    &__close-icon {
        position: absolute;
        right: 14px;
        top: 14px;
        z-index: 10;
        color: $brand-blue;
        width: 30px;
        height: 30px;
        cursor: pointer;
        user-select: none;
        outline: none;

        &:hover {
            color: $brand-black;
        }

        &:focus::before {
            content: '';
            left: -1px;
            top: -1px;
            width: 100%;
            height: 100%;
            position: absolute;
            border: 1px solid $brand-blue;
            border-radius: 5px;
        }

        svg {
            width: 100%;
            height: 100%;
        }
    }

    &__title {
        font-size: 26px;
        outline: none;
        line-height: 36px;
        font-weight: 700;
        text-align: center;
        margin: 78px 0 8px;
        padding: 0 25px;
        z-index: 1;
    }

    &__message {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: 28px;
        font-size: 15px;
        line-height: 20px;
        width: 408px;
        text-align: center;
        z-index: 1;
    }

    &__message-paragraph {
        margin-bottom: 20px;
    }

    &__seats-loading {
        color: $ash;
    }

    &__image {
        position: absolute;
        bottom: 0;
        max-width: 1007px;
        z-index: 0;
    }

    &__seats-error {
        color: $pepper;
        padding: 0 18px;
    }
}
</style>
